import { useIntl } from "react-intl";
import JSONData from "../variables/variables.json";
import Image from "next/image";
import Link from "next/link";
import TranslatedMessage from "./TranslatedMessage";
import { useMemo } from "react";

const Author = (props) => {
	const intl = useIntl();

	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsAuthor = props.author;

	let author = "author";

	let miastoVariable = "miasta." + propsMiasto;

	// JSON VARIABLE
	let miastoJSON = JSONData.miasta[propsMiasto];

	let title = miastoVariable + "." + author + "." + [propsAuthor] + ".title";
	let description = miastoVariable + "." + author + "." + [propsAuthor] + ".description";

	let image = miastoJSON.author[propsAuthor].header.images.url;
	let url = miastoJSON.author[propsAuthor].url;

	const titleMessage = useMemo(() => intl.formatMessage({ id: title }), [intl, title]);
	const ariaLabelMessage = useMemo(() => "Czytaj więcej o autorze " + titleMessage, [titleMessage]);

	return (
		<div className="pd-author">
			<div className="pd-author__image">
				<Image unoptimized 
					alt=""
					src={image}
					width="740"
					height="740"
					quality={100}
					priority
					style={{
						width: "100%",
						height: "auto",
					}}
				/>
			</div>
			<header className="pd-author__header">
				<h3 className="pd-author__title">
					<Link href={"/autorzy/" + url} aria-label={ariaLabelMessage}>
						<TranslatedMessage id={title} />
					</Link>
				</h3>
			</header>
			<p className="pd-author__description">
				<TranslatedMessage id={description} />
			</p>
			<footer className="pd-author__footer">
				<Link
					href={"/autorzy/" + url}
					aria-label={ariaLabelMessage}
					className="pd-author__readmore"
				>
					Czytaj więcej
				</Link>
			</footer>
		</div>
	);
};

export default Author;
